import { create } from "zustand";
import { persist } from "zustand/middleware";
import { isAxiosError } from "axios";
import apiClient from "../api/client";

interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: string;
}

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  isAuthenticated: boolean;
  setAuth: (token: string, refreshToken: string, user: AuthUser) => void;
  logout: () => void;
  refreshAccessToken: () => Promise<string | null>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      refreshToken: null,
      user: null,
      isAuthenticated: false,
      setAuth: (token, refreshToken, user) =>
        set({ token, refreshToken, user, isAuthenticated: true }),
      logout: () => set({ token: null, refreshToken: null, user: null, isAuthenticated: false }),
      refreshAccessToken: async () => {
        const { refreshToken } = get();
        if (!refreshToken) {
          set({ token: null, refreshToken: null, user: null, isAuthenticated: false });
          return null;
        }
        try {
          const response = await apiClient.post("/api/auth/refresh", {
            refresh_token: refreshToken,
          });
          const { access_token, refresh_token, user } = response.data;
          set({
            token: access_token,
            refreshToken: refresh_token,
            user,
            isAuthenticated: true,
          });
          return access_token;
        } catch (err) {
          // Yalnızca refresh token'ı reddedildiyse oturumu kapat; ağ hatası/5xx
          // geçicidir, oturumu silmeden hatayı çağırana ilet.
          const status = isAxiosError(err) ? err.response?.status : undefined;
          if (status === 401 || status === 403) {
            set({ token: null, refreshToken: null, user: null, isAuthenticated: false });
            return null;
          }
          throw err;
        }
      },
    }),
    {
      name: "endeks-auth",
    },
  ),
);
